import { Field, LogicJumpActionType } from 'queries';

import { LogicJumpOption } from '../elements/interface';
import { getQuestionNumber } from './getQuestionNumber';
import { useTranslation } from 'react-i18next';

let memoKey: string = '[]';
let memoValue: LogicJumpOption[] = [];

export const useLogicOptions = (fields: Field[]): LogicJumpOption[] => {
  const { t } = useTranslation();
  const fieldProperties = fields.map((fieldProperty) => ({
    type: LogicJumpActionType.JUMP,
    toFieldId: fieldProperty.id,
    label: fieldProperty.title,
    number: getQuestionNumber(fields, fieldProperty),
  }));

  const endScreenerField = {
    type: LogicJumpActionType.END_FORM,
    label: t('screeningForm.create.questionBuilder.choiceList.endScreenerJump'),
  };
  const defaultLogicOption = {
    type: LogicJumpActionType.NEXT_QUESTION,
    label: t(
      'screeningForm.create.questionBuilder.choiceList.defaultLogicJump',
    ),
    labelDefault: t(
      'screeningForm.create.questionBuilder.choiceList.nextQuestion',
    ),
  };

  const res = [defaultLogicOption, ...fieldProperties, endScreenerField];
  const hash = JSON.stringify(res);

  if (memoKey === hash) {
    return memoValue;
  }
  memoKey = hash;
  memoValue = res;

  return res;
};
